/**
 * Controle de acesso às telas por plano de assinatura.
 *
 * - Telas "god" (Admin, Projetos, NFe Downloader, Lead Scraper) só aparecem
 *   para usuários com cargo `god`, independente do plano.
 * - Durante o TRIAL (sem plano escolhido) o usuário tem acesso a TODAS as telas
 *   não-god.
 * - Ao escolher um plano, o acesso passa a ser limitado às telas do plano.
 *
 * Para a demonstração, o plano escolhido é persistido localmente em
 * `localStorage` (chave DEMO_PLAN_KEY) ao clicar em "Processar pagamento".
 */

export const DEMO_PLAN_KEY = "vidal_demo_plan";

// Contato comercial (plano Grupo Empresarial — "sob consulta").
export const WHATSAPP_SALES_URL =
  "https://wa.me/551153044894?text=" +
  encodeURIComponent(
    "Olá! Tenho interesse no plano Grupo Empresarial da Vidal e gostaria de saber mais sobre as automações personalizadas."
  );

// Telas exclusivas de god — nunca liberadas por plano.
export const GOD_ONLY_DASHBOARDS = [
  "admin",
  "activity-logs",
  "projects",
  "nfe-downloader",
  "lead-scraper",
];

// Ordem de força dos planos (menor → maior).
export const PLAN_ORDER = ["starter", "pro", "enterprise"];

// Todas as telas não-god (usado por Profissional e Grupo Empresarial).
const ALL_DASHBOARDS = [
  "files",
  "transactions",
  "users",
  "certificates",
  "products",
  "clients",
  "suppliers",
  "reforma-tributaria",
  "validacao-fiscal",
  "plcom",
  "notificacoes-fiscais",
  "sped-reviewer",
  "downloads",
  "xml-scan",
  "creditos",
  "email-marketing",
  "automec-fornecedores",
];

// Telas liberadas por plano (ids de dashboard do menu).
export const PLAN_DASHBOARDS = {
  // Essencial
  starter: ["files", "transactions", "users", "certificates"],
  // Profissional → tudo (exceto telas god)
  pro: ALL_DASHBOARDS,
  // Grupo Empresarial → tudo do Profissional + automações personalizadas
  enterprise: ALL_DASHBOARDS,
};

/**
 * Planos exibidos na tela de assinatura (estética/valores da LP Vidal).
 * `slug` casa com PLAN_DASHBOARDS e com o backend (starter/pro/enterprise).
 */
export const DISPLAY_PLANS = [
  {
    slug: "starter",
    name: "Starter",
    tagline: "Essencial",
    description: "Para quem está começando a organizar as notas",
    priceMonthly: 497,
    priceYearly: 397,
    popular: false,
    contact: false,
    features: [
      { text: "Arquivos e Movimentações", included: true },
      { text: "Usuários e Certificados", included: true },
      { text: "Captura automática de NFe e CTe", included: true },
      { text: "1.000 downloads XML/mês", included: true },
      { text: "Produtos, Clientes e Fornecedores", included: false },
      { text: "Notificações Fiscais, SPED e XML Scan", included: false },
    ],
  },
  {
    slug: "pro",
    name: "Profissional",
    tagline: "Completo",
    description: "Todos os recursos para operar sem limites",
    priceMonthly: 897,
    priceYearly: 717,
    popular: true,
    contact: false,
    features: [
      { text: "Acesso a todas as telas do app", included: true, highlight: true },
      { text: "Produtos, Clientes e Fornecedores", included: true },
      { text: "Notificações Fiscais (eCAC/DEC)", included: true },
      { text: "Revisor SPED completo", included: true },
      { text: "XML Scan e Créditos Tributários", included: true },
      { text: "Downloads de XML ilimitados", included: true },
    ],
  },
  {
    slug: "enterprise",
    name: "Grupo Empresarial",
    tagline: "Sob medida",
    description: "Para grupos e grandes operações",
    priceMonthly: null,
    priceYearly: null,
    popular: false,
    contact: true,
    ctaLabel: "Falar no WhatsApp",
    features: [
      { text: "Tudo do plano Profissional", included: true, highlight: true },
      { text: "Automações personalizadas", included: true },
      { text: "Integrações sob medida", included: true },
      { text: "Onboarding e gerente de conta dedicado", included: true },
      { text: "Suporte prioritário com SLA", included: true },
      { text: "Volume e usuários ilimitados", included: true },
    ],
  },
];

